import React, { useState, useEffect } from 'react';
import { Stepper, Box, Text, Title } from '@mantine/core';
import GeneratePage from './GeneratePage';
import RequestPage from './RequestPage';
import DownloadPage from './DownloadPage';
import { pasStudent } from '../../utils/pasStudent';
import { usePlatforma } from '../../platforma';

function StudPage() {
  const SERVER = process.env.REACT_APP_SERVER;
  const [active, setActive] = useState(1);
  const [student, setStudent] = useState();
  const [refresh, setRefresh] = useState(false);
  // cea mai recenta cerere si cea mai recenta cerere semnata (cea valabila)
  const [cerere, setCerere] = useState(null);
  const [cerereSemnata, setCerereSemnata] = useState(null);
  const [professor, setProfessor] = useState();
  const [solicitare, setSolicitare] = useState(null);

  const requestOptions = (method) => {
    return {
      method,
      headers: {
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }
    };
  };

  const getBackendData = async () => {
    const preluareCereri = async () => {
      const response = await fetch(`${SERVER}cerere`, requestOptions('GET'));
      const data = await response.json();
      setCerere(data?.data || null);
      setCerereSemnata(data?.semnata || null);
    };

    const res = await fetch(SERVER + 'user', requestOptions('GET'));
    const studentData = await res.json();
    setStudent(studentData);
    if (studentData.e_repartizat) {
      await preluareCereri();
    }
    if (!studentData.poateTrimite) {
      const statusRes = await fetch(SERVER + 'solicitare/status', requestOptions('GET'));
      const solicitareData = await statusRes.json();
      setSolicitare(solicitareData.solicitare);
      try {
        const resProf = await fetch(`${SERVER}user/profesor/${solicitareData.solicitare.id_profesor}`, requestOptions('GET'));
        const dataProf = await resProf.json();
        setProfessor(dataProf.data);
      } catch (e) {
        console.error(e)
      }
    }
  };

  const { inchisa } = usePlatforma();

  useEffect(() => {
    getBackendData();
  }, [refresh]);

  useEffect(() => {
    if (!student) {
      return;
    }
    setActive(pasStudent(student, cerere, inchisa));
  }, [student, cerere, inchisa]);

  const areCerere = !!cerere;
  const modificariSolicitate = !!cerere?.mesaj_modificari;

  return (
    <Box bg="white" p={{ base: 'md', sm: '50px' }} m={{ base: '80px 8px 24px', sm: '100px 20px' }}>
      <Stepper active={active} onStepClick={setActive}>
        <Stepper.Step label="Profil" description="Completarea profilului" allowStepSelect={false}>
          <Text>Completează-ți profilul regăsit în meniul din stânga, pentru a putea
            vizualiza profesorii disponibili pentru specializarea ta.</Text>
        </Stepper.Step>
        <Stepper.Step label="Solicită o colaborare" description="Alege-ți un coordonator" allowStepSelect={false}>
          <RequestPage student={student} refresh={() => setRefresh(!refresh)} requestOptions={requestOptions} />
        </Stepper.Step>
        <Stepper.Step label="Încarcă cererea" description="Cererea ta PDF"
          allowStepSelect={areCerere && (!!cerereSemnata || modificariSolicitate)}>
          <GeneratePage student={student} refresh={() => setRefresh(!refresh)} solicitare={solicitare}
            requestOptions={requestOptions} professor={professor} cerere={cerere} />
        </Stepper.Step>
        <Stepper.Step label="Descarcă cererea" description="Semnată de coordonator" allowStepSelect={areCerere}>
          <DownloadPage student={student} cerere={cerere} cerereSemnata={cerereSemnata} />
          {cerereSemnata && cerere?.id === cerereSemnata.id && <Box align="center">
            <Text>Titlul lucrării poate fi schimbat doar dacă profesorul coordonator solicită modificări pentru cerere.</Text>
          </Box>}
        </Stepper.Step>
        <Stepper.Completed>
          <Box align="center">
            <Title mt="15px">Felicitări, ai terminat!</Title>
            <Text>Succes în elaborarea lucrării.</Text>
            <Text>Întoarce-te la pasul anterior pentru a descărca cererea ta din nou.</Text>
          </Box>
        </Stepper.Completed>
      </Stepper>
    </Box>
  );
}

export default StudPage;
